import TICKETS_API from 'api/tickets/v1'
import { call, put, takeLatest } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import {
  CLOSE,
  CREATE,
  FETCH_TICKET,
  REOPEN,
  SEND_MESSAGE,
  SET_DATA,
  SET_LOADING,
} from 'modules/Tickets/types'
import { notificationShow } from 'modules/Notifications/actions'
import * as Sentry from '@sentry/browser'
import { FETCH_TICKETS_COUNTER } from 'modules/App/types'

function* fetchTicket({ payload: { id } }) {
  try {
    yield put({
      type: SET_LOADING,
      payload: { loading: true },
    })

    const { response, error } = yield call(TICKETS_API.fetchTicketById, {
      id,
    })

    if (error) {
      throw error
    }

    yield put({
      type: SET_DATA,
      payload: response.data,
    })

    yield put({ type: FETCH_TICKETS_COUNTER })
  } catch (error) {
    Sentry.captureException('tickets fetch error ID:' + id)
    console.logXHR(error)
  } finally {
    yield put({
      type: SET_LOADING,
      payload: { loading: false },
    })
  }
}

function* sendMessage({
  payload: {
    id,
    data,
    meta: { resolve = () => {}, reject = () => {} } = {},
    newTicket,
  },
}) {
  try {
    const { response, error } = newTicket
      ? yield call(TICKETS_API.create, { data })
      : yield call(TICKETS_API.send, { data, id })

    if (error) {
      throw error
    }

    resolve(response.data)
  } catch (e) {
    reject(e)
  }
}

function* close({ payload: { id } }) {
  try {
    const { error } = yield call(TICKETS_API.close, { id })

    if (error) {
      throw error
    }

    //refetch ticket data after close success action
    const { response } = yield call(TICKETS_API.fetchTicketById, {
      id,
    })

    yield put({
      type: SET_DATA,
      payload: response.data,
    })
  } catch (error) {
    const { form } = extractErrors(error.errors)

    if (form) {
      yield put(
        notificationShow({
          type: 'error',
          message: form,
          delay: 10000,
        }),
      )
    }
  }
}

function* reopen({ payload: { id } }) {
  try {
    const { error } = yield call(TICKETS_API.reopen, { id })

    if (error) {
      throw error
    }

    yield put({
      type: SET_DATA,
      payload: { status: 'pending' },
    })
  } catch (error) {
    const { form } = extractErrors(error.errors)

    if (form) {
      yield put(
        notificationShow({
          type: 'error',
          message: form,
          delay: 10000,
        }),
      )
    }
  }
}

export default function* Sagas() {
  yield takeLatest(FETCH_TICKET, fetchTicket)
  yield takeLatest(CREATE, sendMessage)
  yield takeLatest(REOPEN, reopen)
  yield takeLatest(CLOSE, close)
  yield takeLatest(SEND_MESSAGE, sendMessage)
}
